import IntlMessages from "util/IntlMessages";
import FrontendHeader from "../main/header";
import FrontendFooter from "../main/footer";
import IubendaPreferencesLink from "../../../components/IubendaPreferencesLink";

const FrontendCookiePolicyIT = () => {
   return (
      <>
         <FrontendHeader
            title={<IntlMessages id="frontend.cookie_policy_header" />}
         />
         <div className="frontend-container">
            <h4 className="gx-mb-0">Cosa sono i cookie?</h4>
            <p>
               I cookies sono stringhe di testo di piccole dimensioni che vengono
               conservate nel tuo computer quando visiti determinate pagine su
               Internet. I cookies possono svolgere diverse funzioni, come ad esempio
               permetterti di navigare fra le varie pagine in modo efficiente,
               ricordando le tue preferenze, e in generale possono migliorare la
               permanenza dell&apos;utente nel sito.
            </p>
            <p>
               Alcuni cookie sono usati per eseguire autenticazioni informatiche,
               monitoraggio di sessioni e memorizzazione di informazioni specifiche
               sugli utenti che accedono ad una pagina web. Questi cookie, cosiddetti
               tecnici, sono spesso utili, perché possono rendere più veloce e rapida
               la navigazione e fruizione del web, perché ad esempio intervengono a
               facilitare alcune procedure quando fai acquisti online, quando ti
               autentichi ad aree ad accesso riservato o quando un sito web riconosce
               in automatico la lingua che utilizzi di solito.
            </p>
            <p>
               Una particolare tipologia di cookie, detti analytics o di
               monitoraggio, sono utilizzati dai gestori dei siti web per raccogliere
               informazioni, in forma aggregata, sul numero degli utenti e su come
               questi visitano il sito stesso, e quindi elaborare statistiche
               generali sul servizio e sul suo utilizzo.
            </p>
            <p>
               Altri cookie possono invece essere utilizzati per monitorare e
               profilare gli utenti durante la navigazione, studiare i loro movimenti
               e abitudini di consultazione del web o di consumo, anche allo scopo di
               inviare pubblicità di servizi mirati e personalizzati. Parliamo in
               questo caso di cookie di profilazione o di marketing.
            </p>
            <p>
               Può accadere anche che una pagina web contenga cookie provenienti da
               altri siti e contenuti in vari elementi ospitati sulla pagina stessa,
               come ad esempio banner pubblicitari, immagini, video, etc.. Parliamo,
               in questi casi, dei cosiddetti cookie terze parti, che di solito sono
               utilizzati a fini di profilazione. Così i cookie che scarichi su pc,
               smartphone e tablet possono essere letti anche da altri soggetti,
               diversi da quelli che gestiscono le pagine web che visiti.
            </p>
            <p>Se vuoi saperne di più visita i seguenti siti web:</p>
            <p>
               <a
                  href="https://www.allaboutcookies.org"
                  rel="noreferrer"
                  target="_blank"
               >
                  www.allaboutcookies.org
               </a>
               <br />
               <a
                  href="https://www.youronlinechoices.eu"
                  rel="noreferrer"
                  target="_blank"
               >
                  www.youronlinechoices.eu
               </a>
               <br />
               <a
                  href="https://www.garanteprivacy.it/cookie"
                  rel="noreferrer"
                  target="_blank"
               >
                  www.garanteprivacy.it/cookie
               </a>
            </p>
            <h4 className="gx-mb-0 gx-mt-4">Come posso disabilitare i cookies?</h4>
            <p>
               Innanzitutto puoi esprimere le tue preferenze tramite le funzionalità
               presenti nel banner.
               <br />
               Inoltre puoi modificare le impostazioni predefinite di &quot;scurezza
               e privacy&quot; del tuo browser. Questi alcuni esempi relativi ai
               browser più diffusi:
               <br />
               <br />
               Microsoft Edge
               <br />
               Clicca l&apos;icona dei tre puntini posti in orizzontale
               nell&apos;angolo in alto a destra e seleziona
               &apos;Impostazioni&apos;. Seleziona il menu &apos;Privacy, ricerca e
               servizi&apos; e &apos;Cookie ed autorizzazioni sito&apos;. Qui puoi
               regolare le impostazioni dei tuoi cookies.
               <br />
               <br />
               Google Chrome
               <br />
               Clicca l&apos;icona dei tre puntini posti in verticale
               nell&apos;angolo in alto a destra e seleziona &apos;Privacy e
               sicurezza&apos;. Qui puoi regolare le impostazioni dei tuoi cookies.
               <br />
               <br />
               Mozilla Firefox
               <br />
               Dal menu a tendina (tre barre orizzontali sovrapposte)
               nell&apos;angolo in alto a destra seleziona &apos;Impostazioni&apos; e
               &apos;Privacy e sicurezza&apos;. Qui puoi regolare le impostazioni dei
               tuoi cookies.
               <br />
               <br />
               Safari
               <br />
               Dal menu di impostazione scegliere &apos;Preferenze&apos;, e fare clic
               su Privacy. Qui potrete regolare le impostazioni dei vostri cookies.
            </p>
            <h4 className="gx-mb-0 gx-mt-4">Cookie utilizzati dal sito</h4>
            <p>
               La presente informativa è redatta in adempimento degli obblighi
               previsti dall&apos;art. 13 del Regolamento (UE) 2016/679
               (&quot;GDPR&quot;), nonché a quanto previsto dalla normativa
               applicabile in materia di Cookie, e riguarda esclusivamente questo
               sito web.
            </p>
            <p>
               In questo sito - www.prenotazioni.savnoservizi.it - non vengono
               utilizzati cookie. Si fa utilizzo del Local Storage per i seguenti
               elementi:
            </p>
            <table className="gx-table gx-table-responsive gx-mt-4 gx-mb-5 table_cookie_policy">
               <thead>
                  <tr>
                     <th>Chiave</th>
                     <th>Valore</th>
                     <th>Validità</th>
                     <th>Descrizione</th>
                  </tr>
               </thead>
               <tbody>
                  <tr>
                     <td>prenotazioni-elenco_tableFilterReservations</td>
                     <td>
                        &#123;&quot;pagination&quot;:&#123;&quot;limit&quot;:10,&quot;page&quot;:1&#125;,&quot;filter&quot;:&#123;&quot;min_date&quot;:&quot;2025-06-23&quot;&#125;&#125;
                     </td>
                     <td>Fino al logout</td>
                     <td>
                        Salvataggio del filtro impostato per la visualizzazione della
                        tabella con l&apos;elenco delle prenotazioni. Vengono salvate
                        solamente il numero di pagina corrente, la dimensione pagina
                        e la data minima richiesta.
                     </td>
                  </tr>
                  <tr>
                     <td>REMEMBER_ME</td>
                     <td>
                        &#123;&quot;username&quot;:&quot;ABCDEFGHILMNO&quot;,&quot;password&quot;:&quot;password&quot;,&quot;frontend&quot;:true&#125;
                     </td>
                     <td>Fino al logout</td>
                     <td>
                        In caso di login con spunta, &quot;Ricordami&quot; verranno
                        memorizzate le credenziali di accesso inserite.
                     </td>
                  </tr>
                  <tr>
                     <td>SAVNOBOOK_CLIENT_USER</td>
                     <td>
                        &#123;&ldquo;token&rdquo;:&ldquo;eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9....&rdquo;__typename&rdquo;:&ldquo;Token&rdquo;&#125;
                     </td>
                     <td>Fino al logout</td>
                     <td>
                        Token di sessione utilizzato per la connessione con il server
                     </td>
                  </tr>
                  <tr>
                     <td>SAVNOBOOK_CURRENT_RESERVATION</td>
                     <td>
                        &#123;&quot;id&quot;:&quot;68595648b352e810fdc0d5dc&quot;,&quot;status&quot;:&quot;success&quot;,&quot;payment_intent&quot;:null,&quot;__typename&quot;:&quot;ReservationProcessResponse&quot;&#125;
                     </td>
                     <td>Fino al logout</td>
                     <td>Identificativo dell&apos;ultima prenotazione effettuata</td>
                  </tr>
               </tbody>
            </table>
            <p>
               Il sito inoltre incorpora strumenti di tracciamento gestiti da terze
               parti qualificabili come &quot;di esperienza&quot;, ossia contenuti
               esterni (come font, mappe, video e librerie tecniche), che possono
               comportare la trasmissione automatica di dati tecnici, quali indirizzo
               IP, tipo di browser, sistema operativo e altri metadati, verso i
               rispettivi provider, anche in assenza di cookie.
            </p>

            <table className="gx-table gx-table-responsive gx-mt-4 gx-mb-5 table_cookie_policy2">
               <thead>
                  <tr>
                     <th>Nome</th>
                     <th>Provider</th>
                     <th>Scopo</th>
                     <th>Scadenza</th>
                     <th>Tipo</th>
                     <th>
                        Paese di
                        <br />
                        destinazione*
                     </th>
                  </tr>
               </thead>
               <tbody>
                  <tr>
                     <td>Google Fonts</td>
                     <td>Google LLC</td>
                     <td>
                        utilizzato per la visualizzazione di caratteri tipografici
                        web. Al momento della richiesta del font, viene trasmesso
                        l&apos;indirizzo IP dell&apos;utente ai server di Google
                     </td>
                     <td>sessione</td>
                     <td>esperienza</td>
                     <td>USA</td>
                  </tr>
                  <tr>
                     <td>Amazon Web Services - S3 (documenti)</td>
                     <td>Amazon Web Services, Inc.</td>
                     <td>
                        Alcuni documenti allegati alla prenotazione sono forniti
                        tramite link diretti ospitati su Amazon S3. Anche se non
                        vengono utilizzati cookie, il semplice accesso al documento
                        può comportare la trasmissione di dati tecnici (IP, user
                        agent, ecc.) ai server AWS.
                     </td>
                     <td>sessione</td>
                     <td>esperienza</td>
                     <td>USA</td>
                  </tr>
               </tbody>
            </table>

            <h4 className="gx-mb-0 gx-mt-4">Informativa privacy del sito</h4>
            <p>
               Per ulteriori approfondimenti ed una Privacy Policy completa del sito
               clicca{" "}
               <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.savnoservizi.it/it/privacy-policy"
               >
                  qui
               </a>
               .
            </p>
            <h4 className="gx-mb-0 gx-mt-4">Diritti dell&apos;interessato</h4>
            <p>
               L&apos;Interessato ha il diritto di ottenere, nei casi previsti,
               l&apos;accesso ai propri dati personali e la rettifica o la
               cancellazione degli stessi o la limitazione del trattamento che lo
               riguarda o di opporsi al trattamento (artt. 15 e ss. del GDPR),
               contattando il Titolare del Trattamento al seguente indirizzo di posta
               elettronica: savno@savno.it. <br />
               Per modificare le tue preferenze sui cookie installati dal sito
               www.prenotazioni.savnoservizi.it, clicca{" "}
               <IubendaPreferencesLink>qui</IubendaPreferencesLink>.
            </p>
            <h4 className="gx-mb-0 gx-mt-4">
               Responsabile della protezione dei dati (DPO o RPD)
            </h4>
            <p>
               Il Titolare ha designato un Responsabile della protezione dei dati
               (DPO/RPD), contattabile al seguente indirizzo: rpd@savnoservizi.it.
            </p>
            <h4 className="gx-mb-3 gx-mt-4">
               Per maggiori informazioni puoi contattare il Titolare del trattamento:
            </h4>
            <p>
               <strong>SAV.NO. SPA </strong>
               <br />
               Via Magg. G. Piovesana, 158/B - 31015 Conegliano (TV) - Italia
               <br />
               Tel. +39 0438 1711000 - Fax N/D
               <br />
               eMail savno@savno.it
            </p>
            <p className="gx-mt-5">Ultima modifica: 07/07/2025</p>
         </div>
         <FrontendFooter />
      </>
   );
};

export default FrontendCookiePolicyIT;
